import { Icon, IconProps } from "../";

export const FileNoteIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2324 2C13.7628 2.00005 14.2715 2.21091 14.6465 2.58594L19.2803 7.21973C19.4744 7.41387 19.75 7.71968 19.75 8C19.75 8.41421 19.4142 8.75 19 8.75H14.75C13.7835 8.75 13 7.9665 13 7V3.5H6C5.72386 3.5 5.5 3.72386 5.5 4V20C5.5 20.2761 5.72386 20.5 6 20.5H18C18.2761 20.5 18.5 20.2761 18.5 20V10.75C18.5 10.3358 18.8358 10 19.25 10C19.6642 10 20 10.3358 20 10.75V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2H13.2324ZM14.5 7C14.5 7.13807 14.6119 7.25 14.75 7.25H17.1895L14.5 4.56055V7Z"
      />
    </Icon>
  );
};
